import TlsCertificate from '@/store/models/TlsCertificate'
import { loadCertificateForEnv } from '@/api/tls'

let certModel = new TlsCertificate()

export default {

  namespaced: true,

  state: {
    cert: certModel
  },

  mutations: {
    ...certModel.mutations()
  },

  actions: {
    loadCertificateForEnv: ({commit}, envId) => new Promise((resolve, reject) => {
      loadCertificateForEnv(envId, ({data}) => {
        commit('setCertificate', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    cert: state => state.cert
  }

}